import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {SpecialistEnums} from '@namespaces/specialist.namespace';
import {SelectValueInterface} from '@interfaces/select-value.interface';

@Injectable()
export class SpecialistStatusesProvider {
    public data$ = new BehaviorSubject<SelectValueInterface<SpecialistEnums.Status>[]>([
        {id: SpecialistEnums.Status.working,    title: 'Работает'},
        {id: SpecialistEnums.Status.out,        title: 'В отпуске/На больничном'},
        {id: SpecialistEnums.Status.fired,      title: 'Уволен'}
    ]);
}
